import { ApiRoute } from 'api-base-refrence';
import { InformationApiRoute } from './information.api';
import { InformationModel } from 'src/domains/charts/model/information/information.model';
import { NestjsPageFilter } from 'nestjs-model-utility';

export class ChartGenderApiRoute extends ApiRoute {
  static apiName = 'report__customer_segmentation';
  static parent = InformationApiRoute;
  static urlPattern(
    filter?: NestjsPageFilter<keyof InformationModel.ChartGender>,
  ) {
    return '/chart-gender';
  }
}
